import React from 'react';
import CreatePasswordForm from "../../../smart/forms/login/CreatePasswordForm";

const CreatePasswordPage = (props) => {
    return (
        <CreatePasswordForm data={props} />
    )
}

export default CreatePasswordPage
